import React, { PureComponent } from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import { drlLevelLabel } from '../../config/drlThresholds'

function fmt(n, digits = 1) {
  if (n == null || !Number.isFinite(Number(n))) return '—'
  return Number(n).toFixed(digits)
}

/**
 * Modal con desglose de dosis por serie y totales.
 */
export default class DoseReportModal extends PureComponent {
  render() {
    const { open, onClose, report } = this.props
    if (!open) return null

    const rows = (report && report.seriesRows) || []
    const totals = (report && report.totals) || {}
    const level = (report && report.drlLevel) || 'unknown'

    return (
      <Dialog open={!!open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Información de dosis</DialogTitle>
        <DialogContent>
          {!report ? (
            <p>No hay métricas de dosis disponibles en este estudio.</p>
          ) : (
            <>
              <p style={{ marginTop: 0 }}>
                Fuente: <strong>{report.source}</strong>
                {report.profileLabel ? ` · Perfil DRL: ${report.profileLabel}` : ''}
                {' · '}
                <strong>{drlLevelLabel(level)}</strong>
              </p>
              <div style={{ overflowX: 'auto' }}>
                <table
                  style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    fontSize: 13,
                  }}
                >
                  <thead>
                    <tr>
                      {['Serie', 'Mod', 'kV', 'mA', 'mAs', 'CTDIvol', 'DLP', 'DAP'].map(
                        (h) => (
                          <th
                            key={h}
                            style={{
                              textAlign: 'left',
                              borderBottom: '1px solid #ccc',
                              padding: '6px 8px',
                            }}
                          >
                            {h}
                          </th>
                        )
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((r, i) => (
                      <tr key={`dose-row-${i}`}>
                        <td style={td}>
                          {r.seriesNumber != null ? `#${r.seriesNumber} ` : ''}
                          {r.seriesDescription || '—'}
                        </td>
                        <td style={td}>{r.modality || '—'}</td>
                        <td style={td}>{fmt(r.kvp, 0)}</td>
                        <td style={td}>{fmt(r.ma, 0)}</td>
                        <td style={td}>{fmt(r.mas, 1)}</td>
                        <td style={td}>{fmt(r.ctdivol, 2)}</td>
                        <td style={td}>{fmt(r.dlp, 1)}</td>
                        <td style={td}>{fmt(r.dap, 2)}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td style={{ ...td, fontWeight: 700 }} colSpan={5}>
                        Total estudio
                      </td>
                      <td style={{ ...td, fontWeight: 700 }}>{fmt(totals.ctdivol, 2)}</td>
                      <td style={{ ...td, fontWeight: 700 }}>{fmt(totals.dlp, 1)}</td>
                      <td style={{ ...td, fontWeight: 700 }}>{fmt(totals.dap, 2)}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <p style={{ fontSize: 12, opacity: 0.75, marginBottom: 0 }}>
                CTDIvol en mGy · DLP en mGy·cm · DAP en mGy·cm² (según unidad del origen).
                Los umbrales DRL son orientativos.
              </p>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

const td = {
  borderBottom: '1px solid #eee',
  padding: '6px 8px',
  whiteSpace: 'nowrap',
}
